import styled, { css } from 'styled-components';
import { themeHelpers } from '@gotamedia/fluffy/theme';
import { Link as LinkComponent } from '@remix-run/react';
import FluffyCard from '@gotamedia/fluffy/Card';
const Link = styled(LinkComponent).withConfig({
  displayName: "style__Link",
  componentId: "sc-19baow2-0"
})(["width:calc(50% - 10px);", ""], themeHelpers.isSmallDevice(css(["width:unset;"])));
const Card = styled(FluffyCard).withConfig({
  displayName: "style__Card",
  componentId: "sc-19baow2-1"
})(["width:100%;min-height:165px;border-radius:0;", " &:hover{cursor:pointer;background:#f2f2f2;}"], themeHelpers.isSmallDevice(css(["margin-bottom:16px;"])));
const CardImage = styled(Card.Image).withConfig({
  displayName: "style__CardImage",
  componentId: "sc-19baow2-2"
})([""]);
const CardBody = styled(FluffyCard.Body).withConfig({
  displayName: "style__CardBody",
  componentId: "sc-19baow2-3"
})([""]);
const CardSubHeadline = styled(FluffyCard.SubHeadline).withConfig({
  displayName: "style__CardSubHeadline",
  componentId: "sc-19baow2-4"
})(["font-family:\"Sanomat Sans Text\";"]);
const CardHeadline = styled(FluffyCard.Headline).withConfig({
  displayName: "style__CardHeadline",
  componentId: "sc-19baow2-5"
})([""]);
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-19baow2-6"
})(["display:flex;"]);
const HeaderWrapper = styled.div.withConfig({
  displayName: "style__HeaderWrapper",
  componentId: "sc-19baow2-7"
})(["flex:1;display:flex;flex-direction:column;overflow:hidden;margin-right:10px;"]);
const Content = styled.div.withConfig({
  displayName: "style__Content",
  componentId: "sc-19baow2-8"
})(["display:flex;"]);
const ImageWrapper = styled.div.withConfig({
  displayName: "style__ImageWrapper",
  componentId: "sc-19baow2-9"
})(["display:flex;margin:0 0 auto auto;"]);
export { Link, Card, CardImage, CardBody, CardSubHeadline, CardHeadline, Wrapper, HeaderWrapper, Content, ImageWrapper };